import { useAccountAspect } from "@oysterhr/identity"
import { LoadingSpinner } from "@oysterhr/ui"
import { useCompanyPaymentsSettings } from "../../../hooks/useCompanyPaymentsSettings"
import { createContext, PropsWithChildren, useContext } from "react"

/**
 * Contains what payments settings the company has.
 */
export interface CompanyPaymentsSettingsContextValue {
  paymentsMandateSetup?: boolean
  contractorDirectDebitEnabled?: boolean
}

const CompanyPaymentsSettingsContext = createContext<CompanyPaymentsSettingsContextValue | null>(
  null,
)

export const useCompanyPaymentsSettingsContext = () => {
  const context = useContext(CompanyPaymentsSettingsContext)
  if (!context)
    throw new Error(
      "useCompanyPaymentsSettingsContext must be called within CompanyPaymentsSettingsProvider",
    )
  return context
}

export const CompanyPaymentsSettingsProvider = (props: PropsWithChildren<unknown>) => {
  const { isCompany, accountAspect: companyId } = useAccountAspect()
  const { data, loading } = useCompanyPaymentsSettings({
    skip: !isCompany,
    variables: {
      companyId: companyId,
    },
  })
  const paymentsMandateSetup = data?.company?.paymentsSettings?.paymentsMandateSetup
  const contractorDirectDebitEnabled = data?.company?.paymentsSettings?.contractorDdEnabled

  return loading ? (
    <div className="flex h-full w-full items-center justify-center">
      <LoadingSpinner />
    </div>
  ) : (
    <CompanyPaymentsSettingsContext.Provider
      {...props}
      value={{ paymentsMandateSetup, contractorDirectDebitEnabled }}
    />
  )
}
